export default __webpack_public_path__ + "static/media/cases-02-thumbnail.b0502289.jpg";